import * as React from "react"
import { Link } from "react-router-dom"
import {NavigationBar, Layout} from "./layout"
import Table from "react-bootstrap/Table";
import { Typography } from "@mui/material";

const Location = () => {


  return (
  <><NavigationBar/>
{/* Main Content */}
<Layout>
  <img src="/lectureAudioPlatform.png" />
  <Typography variant="body1">
    以下鏈接至英文網站，每個網頁根據年份或者視頻編號分類，點擊單集名字可以收聽或下載音頻文件。<br/><br/>
  </Typography>
  <Typography variant="h3">
    講經<br/>
  <Table ><tbody>
    <tr>
      <td/><td><Link to="/avatamsaka-sutra">華嚴經</Link></td>
    </tr>
    <tr>
      <td/><td><Link to="/sixth-patriarch-sutra">六祖壇經</Link></td>
    </tr>
    <tr>
      <td/><td><Link to="/heart-sutra">心經</Link></td>
    </tr>
    <tr>
      <td/><td><Link to="/vajra-sutra">金剛經</Link></td>
    </tr>
    <tr>
      <td/><td><Link to="/amitabha-sutra">阿彌陀經</Link></td>
    </tr>
    <tr>
      <td/><td><Link to="/earth-store-sutra">地藏經</Link></td>
    </tr>
    <tr>
      <td/><td><Link to="/medicine-master-sutra.html">藥師經</Link></td>
    </tr>
    <tr>
      <td/><td><Link to="/the-bequeathed-teaching-sutra">佛遺教經</Link></td>
    </tr>
    <tr>
      <td/><td><Link to="/the-sutra-in-42-sections">四十二章經</Link></td>
    </tr>
  </tbody></Table>
  <Link to="/dharmatalk-901788">禪</Link><br/>

  <Link to="/dharmatalk">講法</Link><br/>

  <Link to="/fo-qi-archive">佛七</Link><br/>

  <Link to="/chan-qi-archive">禪七</Link><br/>

  <Link to="/outreach-archive">​弘法</Link><br/>

  <a href="https://www.youtube.com/user/MasterYongHua/playlists">講法視頻播放列表</a><br/>
  </Typography>
  <Table style={{tableLayout: "fixed"}}><tbody>
  <tr>
    <td><img src="/lectureAudio1.jpg" /></td>
    <td><img src="/lectureAudio2.jpg" /></td>
    <td><img src="/lectureAudio3.jpg" /></td>
  </tr>
  <tr>
    <td>
      <img src="/lectureAudio4.jpg" height={230} />
    </td>
    <td>
      <img src="/lectureAudio5.jpg" height={230} />
    </td>
    <td><img height={230} src="/lectureAudio6.jpg" /></td>
  </tr>
  <tr>
    <td><img height={230} src="/lectureAudio7.jpg" /></td>
    <td><img height={230} src="/lectureAudio8.jpg" /></td>
    <td><img height={230} src="/lectureAudio9.jpg" /></td>
  </tr>
</tbody></Table>
</Layout></>
)
  }

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */

export default Location;
